import angular from 'angular';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  user: state.user.user,
  userAttributes: state.user.userAttributes,
  subComponent: state.statsbar.activeComponent,
});

angular
  .module('myConsultApp')
  .controller('userEditController', ($ngRedux, $scope, $rootScope, $http, ENV, $timeout) => {
    $scope.userEditDialogOptions = {
      heading: 'Warning!',
      message:
        'You have unsaved changes on this tab! Press OK to continue (undo changes), or Cancel to stay on the current tab and continue editing.',
      buttons: [
        {
          label: 'OK',
          href: '#',
          clickFn: () => {
            $scope.isFormDataChanged = false;
          },
        },
        {
          label: 'Cancel',
          href: '#',
          clickFn: () => {
            $scope.isFormDataChanged = false;
          },
        },
      ],
    };
    $scope.communicationErrorDialogOptions = {
      heading: 'Error',
      message:
        'The request for user communication preferences either failed or is taking too long.  Please refresh the page and try again',
      buttons: [
        {
          label: 'Close',
          href: '#',
          clickFn: () => {
            $scope.showCommunicationErrorDialog = false;
            $scope.isCommunicationErrorTimerRunning = false;
          },
        },
      ],
    };
    $scope.isCommunicationErrorTimerRunning = false;
    $scope.showCommunicationErrorDialog = false;
    $scope.user_update_success = null;
    $scope.communication_update_success = null;
    $scope.loyalty_update_success = null;
    $scope.isFixedUserFields = false;
    $scope.initValues = () => {
      $scope.setUserAttributeHasValidAddress(true);
      $scope.setUserAttributeHasBeenValidated(false);
      $scope.isFormDataChanged = false;
      $scope.isRequestSuccess = false;
      $scope.showValidateAddress = false;
      $scope.isValidateAddressError = false;
      $scope.correctedAddress = null;
      $scope.validateAddress = null;
      $scope.userInfo = {
        identity: {
          first_name: $scope.user?.first_name || '',
          last_name: $scope.user?.last_name || '',
          address_street_address1: $scope.user?.address_information?.address_1 || '',
          address_street_address2: $scope.user?.address_information?.address_2 || '',
          address_city: $scope.user?.address_information?.city || '',
          address_country: $scope.user?.address_information?.country || '',
          address_state: $scope.user?.address_information?.state || '',
          zip: $scope.user?.address_information?.zip || '',
          mobile_phone: $scope.user?.contact_information?.mobile_phone || '',
          email: $scope.user?.contact_information?.email || '',
          email_verified: Boolean($scope.user?.contact_information?.email_verified) || 0,
        },
      };
      $scope.isUserReady = true;
      $scope.sampleUserInfo = angular.copy($scope.userInfo);
      $scope.emailVerification = [
        { name: 'Not Verified', value: 0 },
        { name: 'Verified', value: 1 },
      ];
      $scope.country = { name: '', abbreviation: '' };
      $scope.state = { name: '', abbreviation: '' };
      $scope.countries = [];
      $scope.states = [];
      $scope.filteredStates = [];
      $scope.communication = [];
      $scope.userCommunication = [];
      $scope.hiddenCategories = [];
      $scope.identityErrors = {};
      $scope.communicationErrors = {};
      $scope.processing_update_user = false;
      if ($scope.tabId !== 'user-information') {
        $scope.tabId = 'user_information';
        $scope.userEditTabChanges($scope.tabId, 0);
      }
      $scope.isCommunicationSaveDisabled = false;
      $scope.isSubmitUserDataDisabled = true;
    };

    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.getInfo = async () => {
      // set timer to check if SFMC request is taking too long and show dialog if so
      $scope.isCommunicationErrorTimerRunning = true;
      $timeout(() => {
        if ($scope.isCommunicationErrorTimerRunning === true) {
          $scope.showCommunicationErrorDialog = true;
        }
      }, 20000);
      await $scope.getStates($http, ENV).then((res) => {
        $timeout(() => {
          $scope.states = res;
          if (!isEmpty($scope.user)) {
            $scope.state = $scope.states.filter(
              (state) => state.abbreviation === $scope.user.address_information.state,
            )[0];
          }
        });
      });
      $scope.getCountries($http, ENV).then((res) => {
        $timeout(() => {
          $scope.countries = res.filter((country) => ['US', 'CA'].includes(country.abbreviation));
          if (!isEmpty($scope.user)) {
            $scope.country = $scope.countries.filter(
              (country) => country.abbreviation === $scope.user.address_information.country,
            )[0];
          }
        });
      });
      $scope
        .getCommunication($http, ENV, $scope.user.id)
        .then((res) => {
          $timeout(() => {
            $scope.isCommunicationErrorTimerRunning = false;
            $scope.communication = res;
            $scope.userCommunication = angular.copy($scope.communication);
            $scope.hideCategories();
          });
        })
        .catch((error) => {
          // show SFMC request error dialog if error thrown
          $scope.showCommunicationErrorDialog = true;
        });
    };

    $scope.isSubscribed = (preference) => {
      return preference.PreferenceValue === 'True';
    };

    $scope.isZoetis = (preference) => {
      return preference.preference_type === 'zoetis';
    };

    $scope.isZoetisSubscribed = () => {
      let subscribed = false;
      angular.forEach($scope.userCommunication, (value, key) => {
        if (
          value.preference_type === 'zoetis' &&
          value.preference_category === 'zoetis' &&
          value.user_preferences.PreferenceValue === 'True'
        ) {
          subscribed = true;
        }
      });
      return subscribed;
    };

    $scope.subscribeZoetis = () => {
      angular.forEach($scope.userCommunication, (value, key) => {
        if (value.preference_type === 'zoetis' && value.preference_category === 'zoetis') {
          value.user_preferences.PreferenceValue = 'True';
        }
      });
    };

    $scope.unsubscribeCommunication = (preference) => {
      preference.user_preferences.PreferenceValue = 'False';
      preference.user_preferences.CommunicationPreference = 'neither';

      if (preference.preference_type === 'zoetis' && preference.preference_category === 'zoetis') {
        $scope.unsubscribeAll();
      } else if (preference.preference_type === 'zoetis') {
        $scope.unsubscribeCategory(preference.preference_category);
      }
    };

    $scope.subscribeCommunication = (preference) => {
      $scope.subscribeZoetis();
      preference.user_preferences.PreferenceValue = 'True';
      if (preference.user_preferences.CommunicationPreference === 'neither') {
        preference.user_preferences.CommunicationPreference =
          preference.default_communication_preference;
      }

      if (preference.preference_type === 'zoetis' && preference.preference_category === 'zoetis') {
        $scope.subscribeAll();
      } else if (preference.preference_type === 'zoetis') {
        $scope.subscribeCategory(preference.preference_category);
      }
    };

    $scope.hideCategories = () => {
      $scope.hiddenCategories = [];
      angular.forEach($scope.userCommunication, (value, key) => {
        if (
          value.preference_type === 'zoetis' &&
          value.preference_category !== 'zoetis' &&
          value.user_preferences.PreferenceValue === 'False'
        ) {
          $scope.hiddenCategories.push(value.preference_category);
        }
      });
    };

    $scope.subscribeCategory = (category) => {
      angular.forEach($scope.userCommunication, (value, key) => {
        if (value.preference_type === category) {
          value.user_preferences.PreferenceValue = value.default_setting;
          value.user_preferences.CommunicationPreference = value.default_communication_preference;
        }
      });
      $scope.hideCategories();
    };

    $scope.unsubscribeCategory = (category) => {
      angular.forEach($scope.userCommunication, (value, key) => {
        if (value.preference_type === category) {
          value.user_preferences.PreferenceValue = 'False';
          value.user_preferences.CommunicationPreference = 'neither';
        }
      });
    };

    $scope.unsubscribeAll = () => {
      angular.forEach($scope.userCommunication, (value, key) => {
        value.user_preferences.PreferenceValue = 'False';
        value.user_preferences.CommunicationPreference = 'neither';
      });
    };

    $scope.subscribeAll = () => {
      angular.forEach($scope.userCommunication, (value, key) => {
        value.user_preferences.PreferenceValue = value.default_setting;
        value.user_preferences.CommunicationPreference = value.default_communication_preference;
        if (value.preference_type === 'zoetis' && value.preference_category === 'zoetis') {
          value.user_preferences.PreferenceValue = 'True';
        }
      });
      $scope.hideCategories();
    };

    $scope.toggleEmail = (preference) => {
      if (preference.CommunicationPreference === 'neither') {
        preference.CommunicationPreference = 'email';
      } else if (preference.CommunicationPreference === 'both') {
        preference.CommunicationPreference = 'sms';
      } else if (preference.CommunicationPreference === 'sms') {
        preference.CommunicationPreference = 'both';
      } else {
        preference.CommunicationPreference = 'neither';
      }
    };

    $scope.toggleSMS = (preference) => {
      if (preference.CommunicationPreference === 'neither') {
        preference.CommunicationPreference = 'sms';
      } else if (preference.CommunicationPreference === 'both') {
        preference.CommunicationPreference = 'email';
      } else if (preference.CommunicationPreference === 'email') {
        preference.CommunicationPreference = 'both';
      } else {
        preference.CommunicationPreference = 'neither';
      }
    };

    $scope.filterStates = (states) => {
      if ($scope.country !== undefined) {
        const code = $scope.country.abbreviation === 'CA' ? 31 : 184;

        return states.filter((state) => state.country === code);
      } else {
        return states;
      }
    };

    $scope.searchState = (query) => {
      return new Promise((resolve, reject) => {
        if ($scope.filteredStates && $scope.filteredStates.length > 0) {
          const payload = $scope.filteredStates.filter((state) =>
            state.name.toLowerCase().includes(query.toLowerCase()),
          );
          resolve({ states: payload });
        } else {
          reject({
            state: 'Not Found',
          });
        }
      });
    };

    $scope.selectState = (option) => {
      $scope.state = option;
      if (option.abbreviation == undefined || option.abbreviation == '') {
        $scope.userInfo.identity.address_state = '';
      } else {
        $scope.userInfo.identity.address_state = option.abbreviation;
        let countryAbbreviation = option.country === 31 ? 'CA' : 'US';
        if (countryAbbreviation != $scope.userInfo.identity.address_country) {
          $scope.selectCountry(
            $scope.countries.filter((country) => country.abbreviation === countryAbbreviation)[0],
          );
        }
      }
      $scope.triggerInput('state-search', $scope.state.name);
    };

    $scope.selectCountry = (option) => {
      $scope.country = option;
      if (option.abbreviation == undefined) {
        $scope.userInfo.identity.address_country = '';
      } else {
        $scope.userInfo.identity.address_country = option.abbreviation;
      }
    };

    $scope.setUserProcessing = (item) => {
      $scope.isUserReady = item;
    };

    $scope.cancelAddressValidation = () => {
      $scope.showValidateAddress = false;
      $scope.isValidateAddressError = false;
      $scope.correctedAddress = null;
      $scope.validateAddress = null;
    };

    // wrapper function to catch promise rejections from template that can be ignored
    $scope.updateUserInfoWrapper = (
      showSuccessMessage = true,
      isValidatingAddress,
      useCorrectedAddress,
    ) => {
      $scope
        .updateUserInfo(showSuccessMessage, isValidatingAddress, useCorrectedAddress)
        .catch((error) => {
          console.log(error);
        });
    };

    $scope.updateUserInfo = (showSuccessMessage = true, isValidatingAddress, useCorrectedAddress) =>
      new Promise((resolve, reject) => {
        if (showSuccessMessage === true) {
          $scope.processing_update_user = true;
        }

        const stateElement = document.getElementById('state-search_value');

        if (stateElement && stateElement.value === '') {
          $scope.userInfo.identity.address_state = '';
        }

        $scope
          .updateUser($http, ENV, $scope.user.id, {
            identity: {
              ...$scope.userInfo.identity,
              ...(useCorrectedAddress && $scope.correctedAddress ? $scope.correctedAddress : {}),
              usps_validate: isValidatingAddress,
            },
          })
          .then(() => {
            $scope.sampleUserInfo = angular.copy($scope.userInfo);
            $scope.getUser($http, ENV, $scope.user.id);
            $scope.showValidateAddress = false;
            $scope.correctedAddress = null;
            $scope.isValidateAddressError = false;
            $scope.validateAddress = null;
            $timeout(() => {
              $scope.setUserAttributeHasValidAddress(true);
              $scope.setUserAttributeHasBeenValidated(true);
              if (showSuccessMessage === true) {
                $scope.processing_update_user = false;
                $scope.user_update_success = 'Successfully Updated';
                $('.user-edit-container').animate({ scrollTop: 0 });
                setTimeout(() => {
                  $timeout(() => {
                    $scope.user_update_success = null;
                  });
                }, 5000);
              } else {
                resolve(true);
              }
              $scope.identityErrors = {};
              return true;
            });
          })
          .catch((error) => {
            $scope.showValidateAddress =
              isValidatingAddress && !!error?.data?.identity?.corrected_address;

            $timeout(() => {
              $scope.setUserAttributeHasValidAddress(false);
              $scope.setUserAttributeHasBeenValidated(false);
              if ($scope.showValidateAddress) {
                $scope.processing_update_user = false;
                $scope.correctedAddress = error?.data?.identity?.corrected_address;
                $scope.isValidateAddressError = error?.data?.identity?.corrected_address?.error;
                return;
              }
              // show profile validation errors
              if (showSuccessMessage === true) {
                $scope.processing_update_user = false;
                $scope.identityErrors = $scope.processErrors(error.data, 'identity');
              } else {
                $scope.processing_update_user = false;
                $scope.communicationErrors = $scope.processErrors(error.data, 'identity');
              }
            });
            reject();
            return false;
          });
      });

    $scope.getUTCToLocalDateTime = function (date, format) {
      var dateUtc = moment.utc(date);
      var localDate = moment(dateUtc).local();
      return localDate.format(format);
    };

    $scope.updateCommunicationSettings = async () => {
      $scope.processing_update_user = true;
      $scope.updatedCommunications = [];
      angular.forEach($scope.userCommunication, (value, key) => {
        if (
          value.user_preferences.CommunicationPreference !==
            $scope.communication[key].user_preferences.CommunicationPreference ||
          value.user_preferences.PreferenceValue !==
            $scope.communication[key].user_preferences.PreferenceValue
        ) {
          const preference = {
            PreferenceValue: value.user_preferences.PreferenceValue,
            PreferenceCategory: value.preference_category,
            CommunicationPreference: value.user_preferences.CommunicationPreference,
            LastModifiedDate: $scope.getUTCToLocalDateTime(Date.now(), 'YYYY-MM-DD HH:mm:ss'),
          };
          $scope.updatedCommunications.push(preference);
        }
      });
      var user_updated = true;
      if (!angular.equals($scope.sampleUserInfo, $scope.userInfo)) {
        try {
          user_updated = await $scope.updateUserInfo(false);
        } catch (error) {
          $timeout(() => {
            user_updated = false;
            $scope.processing_update_user = false;
            $scope.communicationErrors = $scope.processErrors(error.data, 'identity');
          });
        }
      }
      if (!user_updated) {
        $scope.processing_update_user = false;
        return;
      }
      $scope.communicationErrors = {};
      if (!angular.equals($scope.communication, $scope.userCommunication)) {
        $scope
          .saveCommunication($http, ENV, $scope.user.id, $scope.updatedCommunications)
          .then((res) => {
            $timeout(() => {
              $scope.processing_update_user = false;
              $scope.communication = res;
              $scope.communication_update_success = 'Successfully Updated';
              $scope.userCommunication = angular.copy($scope.communication);
              $scope.updatedCommunications = [];
              $('.user-edit-container').animate({ scrollTop: 0 });
              setTimeout(() => {
                $timeout(() => {
                  $scope.communication_update_success = null;
                });
              }, 5000);
            });
          })
          .catch((error) => {
            $timeout(() => {
              $scope.processing_update_user = false;
              $scope.communicationErrors = $scope.processErrors(error.data, 'communication');
            });
          });
      } else {
        $scope.processing_update_user = false;
        $scope.communication_update_success = 'Successfully Updated';
        setTimeout(() => {
          $timeout(() => {
            $scope.communication_update_success = null;
          });
        }, 5000);
        $('.user-edit-container').animate({ scrollTop: 0 });
      }
    };

    $scope.userEditTabChanges = (tabId, position) => {
      if ($scope.subComponent !== 'edit-user-profile') {
        return;
      }
      $scope.attemptedTabChange = tabId ?? $scope.attemptedTabChange;
      $scope.attemptedPosition = position ?? $scope.attemptedPosition;

      if (!angular.equals($scope.sampleUserInfo, $scope.userInfo)) {
        $scope.userEditDialogOptions.buttons[0].clickFn = () => {
          $scope.userInfo = angular.copy($scope.sampleUserInfo);
          $scope.state = $scope.states.filter(
            (state) => state.abbreviation === $scope.userInfo.identity.address_state,
          )[0];
          $scope.triggerInput('state-search', $scope.state.name);
          $scope.country = $scope.countries.filter(
            (country) => country.abbreviation === $scope.userInfo.identity.address_country,
          )[0];
          $scope.isFormDataChanged = false;
          $scope.identityErrors = {};
          $scope.userEditTabChanges();
        };
        $scope.isFormDataChanged = true;
        return;
      }

      if (!angular.equals($scope.userCommunication, $scope.communication)) {
        $scope.userEditDialogOptions.buttons[0].clickFn = () => {
          $scope.userCommunication = angular.copy($scope.communication);
          $scope.isFormDataChanged = false;
          $scope.communicationErrors = {};
          $scope.userEditTabChanges();
        };
        $scope.isFormDataChanged = true;
        return;
      }

      if (!$scope.isFormDataChanged) {
        const indicator = document.querySelector('.user-edit .indicator');
        const tabs = document.querySelectorAll('.user-edit .tab');

        if (indicator) {
          indicator.style.marginLeft = `${$scope.attemptedPosition * tabs[0].offsetWidth}px`;
          indicator.style.width = tabs[0].offsetWidth ? `${tabs[0].offsetWidth}px` : `198px`;
        }

        $scope.tabId = $scope.attemptedTabChange;
        $scope.identityErrors = {};
        $scope.communicationErrors = {};
      }

      if ($scope.attemptedTabChange === 'user_information') {
        $timeout(() => {
          $scope.triggerInput('state-search', $scope.state.name);
        }, 500);
      }
    };

    $scope.processErrors = (error, key) => {
      const errors = {};

      Object.keys(error[key]).map((item) => {
        if (Array.isArray(error[key][item])) {
          errors[item] = error[key][item];
        } else if (typeof error[key][item] === 'object') {
          errors[item] = Object.values(error[key][item]);
        } else {
          errors[item] = [error[key][item]];
        }
      });

      return errors;
    };

    $scope.blurState = () => {
      $scope.selectState($scope.state);
    };

    const componentListener = $scope.$watch('subComponent', (newValue, oldValue) => {
      if (newValue === 'edit-user-profile') {
        $scope.initValues();
        $scope.getInfo();
      }
    });

    const userListener = $scope.$watch('user', () => {
      if (!isEmpty($scope.user)) {
        $scope.userInfo = {
          identity: {
            first_name: $scope.user?.first_name || '',
            last_name: $scope.user?.last_name || '',
            address_street_address1: $scope.user?.address_information?.address_1 || '',
            address_street_address2: $scope.user?.address_information?.address_2 || '',
            address_city: $scope.user?.address_information?.city || '',
            address_country: $scope.user?.address_information?.country || '',
            address_state: $scope.user?.address_information?.state || '',
            zip: $scope.user?.address_information?.zip || '',
            mobile_phone: $scope.user?.contact_information?.mobile_phone || '',
            email: $scope.user?.contact_information?.email || '',
            email_verified: Boolean($scope.user?.contact_information?.email_verified) || 0,
          },
        };
        $scope.sampleUserInfo = angular.copy($scope.userInfo);
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
        $scope.isSubmitUserDataDisabled = angular.equals($scope.sampleUserInfo, $scope.userInfo);
      }
    });

    const countryListener = $scope.$watch('country', () => {
      $scope.filteredStates = $scope.filterStates($scope.states);
      if ($scope.filteredStates == undefined || !$scope.filteredStates.includes($scope.state)) {
        $scope.selectState({ name: 'Select a State', abbreviation: '' });
      } else {
        $scope.selectState($scope.state);
      }
    });

    const userCommunicationListener = $scope.$watch(
      'userCommunication',
      () => {
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
      },
      true, // force deepwatch for entire object comparison
    );

    const userInfoListener = $scope.$watch(
      'userInfo',
      () => {
        $scope.isCommunicationSaveDisabled =
          angular.equals($scope.communication, $scope.userCommunication) &&
          angular.equals($scope.sampleUserInfo, $scope.userInfo);
        $scope.isSubmitUserDataDisabled = angular.equals($scope.sampleUserInfo, $scope.userInfo);
      },
      true, // force deepwatch for entire object comparison
    );

    $scope.init();
    $scope.initValues();
    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      // unset attributes when destroying component
      $scope.clearUserAttributes();
      componentListener();
      userListener();
      countryListener();
      userCommunicationListener();
      userInfoListener();
    });
  })
  .directive('userEdit', () => {
    return {
      templateUrl: 'templates/v2/user-edit.html',
    };
  });
